import { useEffect, useState } from "react";
import { Container, Stack } from "react-bootstrap";
import ConnectionContainer from "./connections/ConnectionContainer";
import ApiKeyManagement from "./api-keys/ApiKeyManagement";
import AccountTab from "./account/AccountTab";

export default function SettingsComponent() {
  const [content, setContent] = useState<JSX.Element | null>(null);
  const [activeNavigation, setActiveNavigation] = useState<string>("account");

  useEffect(() => {
    handleActiveNavigationChange();
  }, [activeNavigation]);

  function handleActiveNavigationChange() {
    const identifier = activeNavigation;
    if (identifier === "account") {
      setContent(<AccountTab />);
      return;
    }
    if (identifier === "connections") {
      setContent(<ConnectionContainer />);
      return;
    }
    if (identifier === "api-keys") {
      setContent(<ApiKeyManagement />);
      return;
    }
    // if (identifier === "security") {
    //   setContent(
    //     <div>
    //       <h1>Security</h1>
    //     </div>
    //   );
    //   return;
    // }
  }
  return (
    <Container
      fluid
      className="background-color-light text-white p-0 border-radius-4"
    >
      <Container fluid className="p-3">
        <Stack direction="horizontal" className="justify-content-between pb-3">
          <Container
            fluid
            className={`p-0 settings-navigation-item ${activeNavigation === "account" ? "active" : ""}`}
            onClick={() => setActiveNavigation("account")}
          >
            <div className="text-center">
              <span>Account</span>
            </div>
          </Container>
          {/* <Container
            fluid
            className="p-0 settings-navigation-item"
            onClick={() => setActiveNavigation("connections")}
          >
            <div className="text-center">
              <span>Connections</span>
            </div>
          </Container> */}
          <Container
            fluid
            className={`p-0 settings-navigation-item ${activeNavigation === "api-keys" ? "active" : ""}`}
            onClick={() => setActiveNavigation("api-keys")}
          >
            <div className="text-center">
              <span>API Keys</span>
            </div>
          </Container>
          {/* <Container
            fluid
            className={`p-0 settings-navigation-item ${activeNavigation === "security" ? "active" : ""}`}
            onClick={() => setActiveNavigation("security")}
          >
            <div className="text-center">
              <span>Security</span>
            </div>
          </Container> */}
        </Stack>
        {content}
      </Container>
    </Container>
  );
}
